<template>
  <div class="iv-bg-w iv-main-width" id="topEle" :class="{'mobileBlock':isMobile}">
    <div class="iv-news-detail" v-if="detail.status!=5&&loading">
      <div class="iv-w">
        <p class="iv-detail-title" :title="detail.title">{{ detail.title }}</p>
        <p class="iv-detail-day"><span> 日期：{{ getTime(detail.publishTime) }}</span><span>作者：{{ detail.author }}</span><span>浏览量：{{
            detail.pageViewsNum || 0
          }}</span><span>浏览人次：{{ detail.personViewsNum || 0 }}</span>
<!--          <span-->
<!--            class="iv-detail-share" :class="{'mobileShare':isMobile}" @click="toShare"><i class="el-icon-share"></i>分享({{-->
<!--            detail.shareNum-->
<!--          }})</span>-->
        </p>
<!--        <p class="iv-detail-conone">
          <video src="https://vali-ugc.cp31.ott.cibntv.net/6775A47AE604971FED79454A1/0300200100580E175D16A901B2AB2E667A0EE7-C6D5-9F9E-1B6A-AC74F6676572.mp4?ccode=0512&duration=148&expire=18000&psid=b13ad8fc65ab8f36010021e9420802f841346&ups_client_netip=db8f7ea8&ups_ts=1673927419&ups_userid=&utid=rlQSHOzuyxwCATEHQAumE2CK&vid=XMTc3MzA4MDgxNg%3D%3D&vkey=Bcfa577003e9e8167a3525d4602d3d5c8&eo=0&t=17703c37500a3e&cug=1&fms=1b29edcab3e81fc4&tr=148&le=1dd321d7aff56c38c77ea85b26d1de3f&ckt=1&m_onoff=0&rid=20000000F355545CD5BAC86E89E9E7094CCD7EF602000000&type=3gphd&bc=1&dre=u145&si=611&dst=1" controls="controls" autoplay="autoplay"></video>
        </p>-->
        <p class="iv-detail-conone" v-html="detail?.content?.replaceAll('  ','      ')"></p>

        <!-- <LayoutTitle title="制度附件" v-if="regulationFiles.length > 0">
          <p @click="onDownFile(file.fileId)" class="iv-m-t-16 iv-fs-14 iv-pointer iv-hover-color" v-for="file in regulationFiles" :key="file.fileId">{{file.fileName}}</p>
        </LayoutTitle> -->
        <!--      判断显示成pdf-->
        <div>
          <template v-if="detail.blogFiles!=''">
            <div class="iv-pdf" v-for="(item,index) in regulationFileUrl" :key="index">
           <!-- <div class="iv-pdf" v-for="(item,index) in regulationFileUrl" :key="item" @click="downloadPdf(index)">预览的pdf点击之后屏蔽下载 -->
              <pdf ref="pdf" v-for="i in numPages" :key="i" :src="item" :page="i"></pdf>
            </div>
          </template>
        </div>
        <LayoutTitle title="其他附件" v-if="attachmentFiles.length > 0">
          <p class="iv-m-t-16 iv-fs-14"
             v-for="file in attachmentFiles" :key="file.fileId">
            <Icon v-if="file.isPreview!=1" class="iv-icon-style" type="document-text"></Icon>
            <span v-if="file.isPreview!=1" class=" iv-pointer iv-hover-color" @click="onDownFile(file.fileName,file.name)">{{ file.name }}</span>
            <!-- <span v-if="file.isPreview!=1">[预览]</span> -->
          </p>
        </LayoutTitle>
        <div class="iv-detail-like">
          <p @click="toLike">
            <span :class="(detail.isLike==null||detail.isLike==0)?'iconLike':'iconLikered'"></span>
            <span>{{ detail.likeNum || 0 }}</span>
          </p>
        </div>
        <!--         <Spin size="large" fix v-if="spinShow"></Spin> -->
        <el-card shadow="never" class="comments">
          <div class="header" style="padding-bottom: 10px;">
            评论
          </div>
          <comment></comment>
        </el-card>
      </div>
    </div>
    <a class="totop" @click="goTop" v-if="!isMobile">
      <img src="@/assets/images/totop.png">
    </a>
    <tips-page v-if="detail.status==5&&loading"></tips-page>
    <Loading class="iv-loading" v-if="!loading"></Loading>
  </div>
</template>

<script>

import {timeFormat} from '@/utils'
import LayoutTitle from '@/components/layout/layout-title'
// import pdf from 'vue-pdf'
// import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import pdf from 'vue-pdf-signature'
import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory'
// import Ipcomment  from "@/views/news-core/news-detail/comment/Ipcomment";
import comment from "./comment/Ipcomment"
import TipsPage from "@/views/error/tipsPage.vue";
import Loading from "@/components/loading"

export default {
  data() {
    return {
      detail: {},
      regulationFileUrl: [],
      attachmentFiles: [],
      pdfFiles: [],
      numPages: 1,
      timer: null, // 定时器
      isMobile: false,
      once: true,
      loading:false,
    }
  },
  created() {
    console.log('news-details', this.$route.query)
    //修复个人中心过来浏览器可以点击上一页问题
    // if (this.$route.query.from === 'portal') {
    //   //清空history
    //   // history.pushState(null, null, location.href);
    //   this.$router.go(-history.length-1)
    //   // history.replaceState(null, null, location.href);
    //   console.log('history999', history.length)
    // }
    this.isMobile = this.$route.query.device == 'mobile'?true:false
    if (this.$route.query.accessToken) {
      localStorage.setItem('token', this.$route.query.accessToken)
    }
    if(this.$route.query.from=='oa'){ // oa跳转过来
      this.jumpResult()
    }else{ //正常情况
      this.initTabs()
    }
  },
  methods: {
    initTabs() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getBlogInfo',
        method: 'get',
        data: {
          id: this.$route.query.infoId
        }
      }).then(({data}) => {
        this.detail = data.data
        //status（0未提交(模板) 1 审核中 2审核通过 3发布审核中 4发布(模板) 5撤销发布。
        if(data.data.status==4){
          this.detail.infoContent = unescape(this.detail.infoContent)
          if (this.detail.blogFiles) {
            let _blogFiles = JSON.parse(this.detail.blogFiles)
            let _pdfFiles = [];
            let _otherFiles = [];
            for (var i = 0; i < _blogFiles.length; i++) {
              // if (_blogFiles[i].type == 'pdf') {
              if (_blogFiles[i].type == 'pdf' && _blogFiles[i].isPreview == 1) {
                // _blogFiles[i].src = process.env.VUE_APP_BASE_API + _blogFiles[i].url
                // _blogFiles[i].src = process.env.VUE_APP_BASE_API + _blogFiles[i].fileName
                _blogFiles[i].src = _blogFiles[i].fileName
                _pdfFiles.push(_blogFiles[i])
              }
              _otherFiles.push(_blogFiles[i])
            }
            this.attachmentFiles = _otherFiles
            this.pdfFiles = _pdfFiles
            this.getNumPages(_pdfFiles)
          }
        }else if(data.data.status==5){//撤销发布
          console.log(this.detail.status)
          // this.$Message.info('此新闻已撤销发布')
        }else{
          this.$Message.info('此新闻暂未发布！')
        }
        this.loading = true;
      })
    },
    jumpResult(){
      this.$ajax({
        url: 'api-qixuan/cms/front/getBlogJumpResult',
        method: 'get',
        data: {
          id: this.$route.query.infoId
        }
      }).then(({data}) => {
        if(data.code==500) {
          this.$Message.info(data.msg);
        }else{
          this.initTabs()
        }
      })
    },
    getNumPages(url) {
      var loadingTask = [];
      for (let i = 0; i < url.length; i++) {
        if(!url[i].fileName.includes("outfile")&&url[i].fileName.indexOf('/prod-api')==-1){
          url[i].fileName = '/prod-api' + url[i].fileName
          console.log(url[i].fileName)
        }
        loadingTask.push(pdf.createLoadingTask({
          url: url[i].fileName,
          cMapPacked: true,
          CMapReaderFactory
        }))
        loadingTask[i].promise.then(pdf => {
          this.regulationFileUrl.push(loadingTask[i])
          this.numPages = pdf.numPages
          this.timer = setInterval(() => {
            this.getCanvasLoaded()
          }, 1000)
        }).catch((err) => {
          console.error('pdf加载失败')
        })
      }

    },
    getCanvasLoaded() {
      let canvasList = document.getElementsByTagName('canvas')
      for (let i = 0; i < canvasList.length; i++) {
        if (canvasList[i].getContext('2d').getImageData(10, 10, 50, 50).data[0] > 0 && i == (canvasList.length - 1)) {
          clearInterval()
          this.timer = null
        }
      }
    },
    downloadPdf(index) {
      const a = document.createElement('a')
      a.setAttribute('download', this.pdfFiles[index].name)
      a.setAttribute('target', '_blank')
      // a.setAttribute('href',  process.env.VUE_APP_URL+'/'+this.pdfFiles[index].fileName)
      // a.setAttribute('href', '/api-qixuan' + this.pdfFiles[index].fileName)
      // a.setAttribute('href', '/api-qixuan' + this.pdfFiles[index].fileName)
      a.setAttribute('href', this.pdfFiles[index].fileName)
      a.click()
    },
    toShare() {
      if (!this.isMobile) {
        this.$clipboard(location.origin+'/#/newsDetail?infoId='+this.$route.query.infoId)
        // this.$clipboard(window.location.href)
        if (this.$clipboard(location.origin+'/#/newsDetail?infoId='+this.$route.query.infoId)) {
          this.$Message.success("已成功复制到剪切板")
          this.$ajax({
            url: 'api-qixuan/cms/front/share',
            method: 'get',
            data: {
              id: this.$route.query.infoId
            }
          }).then(({data}) => {
            this.detail.shareNum += 1;
            this.loading = true;
          })
        } else {
          this.$Message.error("分享失败")
        }
      } else {
        this.$Message.error("复制网址失败，请手动复制分享")
        // this.mobileCopy(window.location.href)
      }

    },
    toLike() {
      if (!this.once) {
        return false
      }
      this.once = false
      this.$ajax({
        url: 'api-qixuan/cms/front/like',
        method: 'get',
        data: {
          id: this.$route.query.infoId
        }
      }).then(({data}) => {
        this.loading = true;
        if (data.code == 200) {
          this.once = true
          this.detail.likeNum = data.data
          this.detail.isLike = data.isLike
          this.$Message.success(data.msg)
        }
      })
    },

    getTime(d) {
      return timeFormat(d)
    },
    //获取文件信息
    getActivityFiles(groupId) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-qixuan/file/listFilesByGroupId',
          method: 'GET',
          data: {
            isPage: false,
            groupId: groupId
          }
        }).then(({data}) => {
          this.loading = true;
          resolve(data.data || [])
        })
      })
    },
    onDownFile(url, name) {
      const a = document.createElement('a')
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      // a.setAttribute('href', process.env.VUE_APP_URL+url)
      // a.setAttribute('href', '/api-qixuan' + url)
      a.setAttribute('href', url)
      a.click()
    },
    viewUrl(id) {
      let url = `api-qixuan/file/downloadFile?fileId=${id}`
      return url
    },
    goTop() {
      const a = document.getElementById("topEle");
      a.scrollIntoView();
    },
    selectText(textbox, startIndex, stopIndex) {
      if (textbox.createTextRange) {    // ie
        const range = textbox.createTextRange()
        range.collapse(true)
        range.moveStart('character', startIndex) // 起始光标
        range.moveEnd('character', stopIndex - startIndex) // 结束光标
        range.select() // 不兼容苹果
      } else {    // firefox/chrome    textbox.setSelectionRange(startIndex, stopIndex)
        textbox.focus()
      }
    },
    mobileCopy(txt) {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1  // 要先判断当前是什么系统，否则会报错，无法执行语句
      if (isAndroid) {
        const _input = document.createElement('input') // 直接构建input
        _input.style.position = 'fixed'
        _input.style.left = '-1000px'
        _input.style.top = '0px'
        _input.style.zIndex = '-1000'
        _input.value = txt // 设置内容
        document.body.appendChild(_input) // 添加临时实例
        _input.select() // 选择实例内容
        document.execCommand('Copy') // 执行复制
        document.body.removeChild(_input) // 删除临时实例
        if (document.execCommand('Copy')) {
          this.$Message.success('复制成功')
        } else {
          this.$Message.error('复制失败，请手动复制')
        }
      } else {    // 数字没有 .length 不能执行selectText 需要转化成字符串
        const textString = txt.toString()
        let input = document.querySelector('#copy-input')
        if (!input) {
          input = document.createElement('input')
          input.id = 'copy-input'
          input.readOnly = 'readOnly'
          input.style.position = 'absolute'
          input.style.left = '-1000px'
          input.style.zIndex = '-1000'
          document.body.appendChild(input)

          input.value = textString      // ios必须先选中文字且不支持 input.select()
          this.selectText(input, 0, textString.length)
          console.log(document.execCommand('copy'), 'execCommand')
          if (document.execCommand('copy')) {
            document.execCommand('copy')
            this.$Message.success('复制成功')
          } else {
            this.$Message.error('复制失败，请手动输入')
          }
          input.blur()
          document.body.removeChild(input)      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法      // 选择文本。createTextRange(setSelectionRange)是input方法    }
        }
      }
    },
  },
  components: {
    TipsPage,
    LayoutTitle,
    pdf,
    comment,
    Loading
  }
}
</script>
<style>
.iv-detail-conone img {
  max-width: 100% !important;
  height: auto;
  cursor: default !important;
}
</style>
<style lang="scss" scoped>
::v-deep .ql-align-right{
  text-align: right;
}
::v-deep .ql-align-left{
  text-align: left;
}
::v-deep .ql-align-center{
  text-align: center;
}
::v-deep.ivu-page-options{
  height: 32px!important;;
}
.iv-pdf {
  box-shadow: 0 0 8px rgba(98, 98, 98, .05);
  margin-top: 32px;
}

.iv-bg-w {
  padding-top: 70px;
  //background-color: white;
  height: 100%;

  &.mobileBlock {
    padding-top: 0 !important;
    height: 100vh;
  }

  .iv-loading {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 9999;
    }
}

.iv-news-detail {
  //background-color: white;
  white-space: pre-wrap;
  .iv-w {
    width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: white;
  }

  .iv-detail-title {
    font-size: 36px;
    font-weight: bold;
    color: #000000;
    line-height: 44px;
    // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
    width: 100%;
    // max-width: 1200px;
    text-align: center;
    // height: 44px;
  }

  .iv-detail-day {
    width: 100%;
    text-align: center;
    margin-top: 32px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    position: relative;

    .iv-detail-share {
      position: absolute;
      right: 150px;
      top: 0;
      cursor: pointer;

      &.mobileShare {
        position: initial;
      }
    }

    span {
      margin-left: 10px;
    }
  }

  .iv-detail-conone {
    margin-top: 63px;
    padding-bottom: 30px;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 36px;
    color: #000000;
    video{
      max-width: 100%;
      margin:0 auto;
      display: block;
    }
  }
    ::v-deep .iv-detail-conone ul,::v-deep .iv-detail-conone ol,::v-deep .iv-detail-conone li{
      list-style: revert;
      padding: revert;
      margin: revert;
    }

    ::v-deep.iv-detail-conone blockquote{
      border-left: 4px solid #ccc;
      margin-bottom: 5px;
      margin-top: 5px ;
      padding-left: 16px ;
      margin-left:0;
      margin-right:0;
    }
    ::v-deep .iv-detail-conone pre.ql-syntax{
      background-color: #23241f;
      color: #f8f8f2;
      overflow: visible;
    }
    ::v-deep .iv-detail-conone p{
      margin: 0 !important;
      padding: 0 !important;
    }
    ::v-deep.iv-detail-conone a{
      color: #06c;
      text-decoration: underline;
    }
    ::v-deep .ql-align-right {
      text-align: right;
    }
    ::v-deep .ql-align-left{
      text-align: left;
    }
    ::v-deep .ql-align-center{
      text-align: center;
    }
    //::v-deep .el-popper{
    //  box-shadow: 0 2px 4px 0 rgb(34 36 38 / 12%);
    //}
    ::v-deep .ql-indent-1:not(.ql-direction-rtl){
      padding-left: 3em;
    }
    ::v-deep .ql-indent-2:not(.ql-direction-rtl){
      padding-left: 6em;
    }
    ::v-deep .ql-indent-3:not(.ql-direction-rtl){
      padding-left: 9em;
    }
    ::v-deep .ql-indent-4:not(.ql-direction-rtl){
      padding-left: 12em;
    }
    ::v-deep .ql-indent-5:not(.ql-direction-rtl){
      padding-left: 15em;
    }
    ::v-deep .ql-indent-6:not(.ql-direction-rtl){
      padding-left: 18em;
    }
    ::v-deep .ql-indent-7:not(.ql-direction-rtl){
      padding-left: 21em;
    }
    ::v-deep .ql-indent-8:not(.ql-direction-rtl){
      padding-left: 24em;
    }
    ::v-deep .ql-size-small{
      font-size: .75em;
    }
    ::v-deep .ql-size-large{
      font-size: 1.5em ;
    }
    ::v-deep .ql-size-huge{
      font-size: 2.5em ;
    }
  .ql-video{
    max-width: 100% !important;
    margin:0 auto !important;
    display: block !important;
  }
  video{
    max-width: 100% !important;
    margin:0 auto !important;
    display: block !important;
  }
  .iv-detail-like {
    height: 50px;
    font-size: 18px;
    margin-bottom: 20px;
    line-height: 50px;
    margin-top: 20px;
    padding-top: 10px;
    border-top: 1px dashed #ccc;

    p {
      text-align: right;
      float: right;
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    span {
      margin-left: 5px;
      display: inline-block;
    }

    .iconLike {
      width: 25px;
      height: 25px;
      background: url("~@/assets/images/icon-like.png") no-repeat;
      background-size: 25px;
    }
    .iconLikered{
      width: 25px;
      height: 25px;
      background: url("~@/assets/images/icon-like-blue.png") no-repeat;
      background-size: 25px;
    }
  }

  img {
    width: 800px;
    height: 450px;
    margin: 46px 0 50px 200px;
  }

  .iv-detail-two {
    font-size: 16px;
    line-height: 36px;
    color: #000000;
    text-indent: 2em;
    margin-bottom: 40px;
  }

  .iv-detail-three {
    font-size: 16px;
    line-height: 36px;
    color: #000000;
    text-indent: 2em;
  }
}

.iv-icon-style {
  margin-right: 5px;
}

// totop
.totop {
  position: fixed;
  bottom: 80px;
  right: 24px;
  z-index: 10;
  width: 48px;
  height: 48px;
  cursor: pointer;

  img {
    width: 27px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    //height: 100%;
  }
}
</style>
